import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { ROLES } from '@/hooks/useRoles';

/**
 * Where someone lands after signing in, or on opening the site's root:
 * superadmins on Platform Analytics, everyone else on their own dashboard.
 */
export function homePathFor(roles: readonly string[]): string {
  return roles.includes(ROLES.SUPER_ADMIN) ? '/admin/analytics' : '/dashboard';
}

export function HomeRedirect() {
  const { user } = useAuth();
  return <Navigate to={homePathFor(user?.roles ?? [])} replace />;
}
